exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "atomic-search-interface{grid-template-areas:\". . atomic-section-search .\" \". atomic-section-main atomic-section-facets .\" \". atomic-section-facets . .\"}.container-fluid:has(>.c-listing-header){padding:0}.HCxF .c-listing-header{margin:0;padding:0;padding-top:30px;@media (min-width:768px){padding-top:30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dea0b790","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/components/hcxf/hcxf-publication-hub.vue
// module id = 563
// module chunks = 0 1